// ----------------------------------------------------------------------

const ROOTS = {
  AUTH: '/auth',
  DASHBOARD: '/dashboard',
};

// ----------------------------------------------------------------------

export const paths = {
  minimalUI: 'https://mui.com/store/items/minimal-dashboard/',
  // AUTH
  auth: {
    jwt: {
      login: `${ROOTS.AUTH}/jwt/login`,
      forgotPassword: `${ROOTS.AUTH}/jwt/forgot-password`
    },
  },
  // DASHBOARD
  dashboard: {
    root: `${ROOTS.DASHBOARD}/user/customer`,
    user: {
      root: `${ROOTS.DASHBOARD}/user/customer`,
      customer: `${ROOTS.DASHBOARD}/user/customer`,
      support: `${ROOTS.DASHBOARD}/user/support`,
      credit: `${ROOTS.DASHBOARD}/user/credit`,
      credit_approval: `${ROOTS.DASHBOARD}/user/credit_approval`,
      staff: `${ROOTS.DASHBOARD}/user/staff`
    },
    item: {
      root: `${ROOTS.DASHBOARD}/item/insights`,
      insights: `${ROOTS.DASHBOARD}/item/insights`,
      product: `${ROOTS.DASHBOARD}/item/product`,
      pricing: `${ROOTS.DASHBOARD}/item/pricing`,
      bulk_pricing: `${ROOTS.DASHBOARD}/item/bulk_pricing`,
      combo: `${ROOTS.DASHBOARD}/item/combo`,
      package: `${ROOTS.DASHBOARD}/item/package`,
      category: `${ROOTS.DASHBOARD}/item/category`,
      product_group: `${ROOTS.DASHBOARD}/item/product_group`,
      expires: `${ROOTS.DASHBOARD}/item/expires`,
      damages: `${ROOTS.DASHBOARD}/item/damages`
    },
    order: {
      root: `${ROOTS.DASHBOARD}/order/insights`,
      insights: `${ROOTS.DASHBOARD}/order/insights`,
      all: `${ROOTS.DASHBOARD}/order/all`,
      review: `${ROOTS.DASHBOARD}/order/review`
    },
    delivery: {
      root: `${ROOTS.DASHBOARD}/delivery/insights`,
      insights: `${ROOTS.DASHBOARD}/delivery/insights`,
      driver: `${ROOTS.DASHBOARD}/delivery/driver`,
      returns: `${ROOTS.DASHBOARD}/delivery/returns`,
      returns_refund: `${ROOTS.DASHBOARD}/delivery/returns_refund`,
      zones: `${ROOTS.DASHBOARD}/delivery/zones`,
      cities: `${ROOTS.DASHBOARD}/delivery/cities`,
      utilities: `${ROOTS.DASHBOARD}/delivery/utilities`
    },
    configuration: {
      root: `${ROOTS.DASHBOARD}/configuration/banner`,
      banner: `${ROOTS.DASHBOARD}/configuration/banner`,
      featured: `${ROOTS.DASHBOARD}/configuration/featured`
    },
    profile: {
      root: `${ROOTS.DASHBOARD}/profile/security`,
      security: `${ROOTS.DASHBOARD}/profile/security`
    }
  }
};